var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"width":"100%","height":"100%","controls":""}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}}),_c('p',{staticClass:"vjs-no-js"},[_vm._v(" To view this video please enable JavaScript ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }